import type { FaireProductEntity } from "../../entity_types/product";

export const p_3acv96vu7y: FaireProductEntity = {
  token: "p_3acv96vu7y",
  type: "product",
  name: "Organic All Over Balm",
  brandToken: "b_1q5xt82q",
  brandName: "Earth Mama Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/19ebd5ba77e46e3ca73440ee8a8e1beac936eecc829e742bff335c6ecd1e2269.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c8fe5f2815b34c1a7ce8676e95c4d7c3decaea26bccb969944a7e7c67c5ad71a.jpeg",
    "https://cdn.faire.com/fastly/e9540288df66c91e20b1fdb01484e1c9aa8fd35d8ba49911bd461092703bfe3c.jpeg",
    "https://cdn.faire.com/fastly/fe5b48c4d11969d2c558f5bffd1dd5115ec21f75951b384d952009ddcbdcfb60.jpeg",
    "https://cdn.faire.com/fastly/520579420a2532d2fe354fd1fdc154b9efb40dfb3f5809f4da39bf30cefde226.jpeg",
    "https://cdn.faire.com/fastly/17cc6fdc7e9cbf6b2f8126e8f26f68ef61478f91ee147769595110508f4101d7.jpeg",
    "https://cdn.faire.com/fastly/222a6663f54e385b7f25c70bc4b18cc16322cde4b8355185dc7d6da55ffab367.jpeg",
  ],
  priceDollars: 14.95,
  description:
    "Earth Mama's Organic All Over Balm is a thoughtfully-formulated blend of organic ingredients including sunflower seed oil, shea butter, and calendula for an organic alternative to petroleum jelly. Use anywhere and everywhere that needs some extra TLC, on babies, big kids and grown-ups too. \n\n\n * USDA Certified Organic, Leaping Bunny Certified & Plastic Neutral \n\n * No petrolatum, artificial preservatives, or artificial fragrance\n\n * Apply liberally on dry spots. Repeat as needed. \n",
  tags: [],
  msrpDollars: 22.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:50.932Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
